<template>
<div style="margin-right:20px;">
    <button class="btn btn-default btn-sm" style="height: 40px;" @click="send()">Skicka SMS med länk till Google recensioner</button>
</div>
</template>

<script>
export default {
    props: {
        customerId: {
            required: true
        }
    },
    data () {
        return {

        }
    },
    methods: {
        send () {
            const self = this

            if (!confirm('Är du säker?')) {
                return
            }

            self.$http.post('/customers/' + self.customerId + '/sendReviewSms').then((response) => {
                console.log('sendReviewSms response')
                console.log(response.data)

                bus.$emit('notify', 'SMS med länk till Google recensioner har skickats till kunden')
                bus.$emit('log-reload')
            }, (response) => {
                console.log(JSON.stringify(response))
            })
        }
    }
}
</script>
